import React from 'react'
import { IGeneralTariffModel } from './GeneralTariffModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IGeneralTariffModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (generalTariff: IGeneralTariffModel) => void
  onDelete?: (generalTariff: IGeneralTariffModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const GeneralTariffTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {

  const formatDate = (date: string | null | undefined) =>
    date ? new Date(date).toLocaleDateString() : ''

  // DataTable için index ekle
  const dataWithIndex = data.map((item, idx) => ({ ...item, _index: idx + 1 }))

  const generalTariffColumns: TableColumn<IGeneralTariffModel & { _index: number }>[] = [
      { 
      key: 'priceList', 
      label: 'Fiyat Listesi', 
      render: (item) => (
        <button 
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => console.log('Fiyat listesine git:', item.id)}
        >
          {item._index}. Fiyat Listesine Git&nbsp;
          <i className="bi bi-arrow-right"></i>
        </button>
      )
    },
    { key: 'rateName', label: 'Tarife Adı', className: 'fw-semibold', sortable: true },
    { key: 'rateGroup', label: 'Tarife Grubu', className: 'fw-semibold' },
    { key: 'actionDate', label: 'Tarih', render: (item) => formatDate(item.actionDate) },
    { key: 'cancellationDate', label: 'İptal Tarihi', render: (item) => formatDate(item.cancellationDate) },
    { key: 'startDate', label: 'Başlangıç Tarihi', render: (item) => formatDate(item.startDate) },
    { key: 'endDate', label: 'Bitiş Tarihi', render: (item) => formatDate(item.endDate) },
  ]

  const generalTariffActions: TableAction<IGeneralTariffModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (generalTariff) => onEdit?.(generalTariff),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (generalTariff) => onDelete?.(generalTariff),
    },
  ]

  return (
    <DataTable
      data={dataWithIndex} // index eklenmiş data
      columns={generalTariffColumns}
      actions={generalTariffActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Genel Tarife bulunamadı'
    />
  )
}
